// This is for the DYMO Lavel printing library.
// This wraps the Dymo Framework and adds specific logic and 'view' to suit our needs.

import './DYMO.Label.Framework.2.0.2.js' /* global dymo:false */
import { sortBy, filter, uniq } from 'lodash'
import Raven from 'raven-js'
import moment, { displayFormat } from 'helpers/moment'
import { compareParseInt } from 'helpers/index'
import { getBins } from 'helpers/orders'

const getLabelXml = () => {
  // TextFitMode = None, AlwaysFit, ShrinkToFit
  // HorizontalAlignment = Left, Center, right

  return `<DieCutLabel Version="8.0" Units="twips">
    <PaperOrientation>Landscape</PaperOrientation>
    <Id>Address</Id>
    <PaperName>30252 Address</PaperName>
    <DrawCommands/>
    <ObjectInfo>
      <TextObject>
        <Name>Text</Name>
        <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
        <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
        <LinkedObjectName></LinkedObjectName>
        <Rotation>Rotation0</Rotation>
        <IsMirrored>False</IsMirrored>
        <IsVariable>True</IsVariable>
        <HorizontalAlignment>Left</HorizontalAlignment>
        <VerticalAlignment>Middle</VerticalAlignment>
        <TextFitMode>AlwaysFit</TextFitMode>
        <UseFullFontHeight>True</UseFullFontHeight>
        <Verticalized>False</Verticalized>
        <StyledText/>
      </TextObject>
      <Bounds X="332" Y="150" Width="4455" Height="1260" />
    </ObjectInfo>
  </DieCutLabel>`
}

const ordersArray = (orders) => {
  const array = []

  // get a unique list of customer_ids, grab their orders, and then add those orders to the array
  uniq(orders.map(o => o.customer_id))
    .forEach(customerId => {
      // sort orders by product name
      sortBy(
        // get orders for this customer
        filter(orders, (o) => compareParseInt(customerId, o.customer_id)),
        'route.name'
      ).forEach((o, i) => { // forEach customer's order, sorted
        array.push(o)
      })
    })

  return array
}

// Apparently this needs to be valid XML (rather than XHTML)..
const escapeXml = (str) => {
  let result = str
  const findReplace = [
    [/&/g, '&amp;'],  // &
    [/</g, '&lt;'],   // <
    [/>/g, '&gt;'],   // >
    [/"/g, '&quot;'], // "
    [/'/g, '&apos;']  // '
  ]

  for (let i = 0; i < findReplace.length; ++i) {
    result = result.replace(findReplace[i][0], findReplace[i][1])
  }

  return result
}

// requires an array of orders
// returns a Promise or throws an error
export const print = async (orders) => {
  return await dymo.label.framework.init(async () => {
    const paramsXml = dymo.label.framework.createLabelWriterPrintParamsXml({ })
    const labelSetXml = new dymo.label.framework.LabelSetBuilder()

    const addLabel = (o) => labelSetXml.addRecord().setTextMarkup('Text',
      `<font Size='12'>${escapeXml(`${o.customer.name} (${moment(o.date).format(displayFormat)})`)}</font>
       <font Size='14'>${escapeXml(`Route ${o.route.name}${o.bin && ` »» ${o.bin} ««` || ''}`)}</font>
       <font Size='16'>${escapeXml(`${o.qty} ${o.uom.shorthand || o.uom.name || ''} ${o.option && o.option.name || ''} – ${o.product.name}`)}</font>
       <font Size='14'>${escapeXml(`${o.notes && typeof o.notes.replace === 'function' ? `« ${o.notes.replace(/\n/g, ' ')} »` : ''}`)}</font>`)

    let count = 0
    ordersArray(orders).forEach(order => {
      const bins = getBins(order)

      if (!bins || bins.length <= 1) {
        count++
        return addLabel(order)
      }

      bins.map((qty, i) => {
        let binOrder = Object.assign({}, order, {
          qty,
          bin: `Bin ${i + 1}/${bins.length}`
        })

        count++
        addLabel(binOrder)
      })
    })

    if (count < orders.length) {
      Raven.captureException(new Error('Printed less labels than orders!'), {
        extra: {
          count,
          orders: orders.map(o => o.id)
        }
      })
    }

    // get the printerName after the generation for debugging!
    const printerName = await dymo.label.framework.getPrintersAsync()
      .then(printers => {
        const labelPrinters = (printers || []).filter(printer => printer.printerType === 'LabelWriterPrinter') || []
        const printer = labelPrinters.find(o => o && o.name) // just take the first one...

        if (!printer || !printer.name) {
          console.error(`No Valid DYMO Printer could be used.
            ${printers.length} printers found – ${labelPrinters.length} were label printers.`)
          return false
        }

        return printer.name
      })

    if (!printerName) return false

    return await dymo.label.framework.printLabelAsync(printerName, paramsXml, getLabelXml(), labelSetXml)
  })
}



// WEBPACK FOOTER //
// ./src/vendor/dymo/index.js